import React from 'react'
import type { StartLabelSelectFieldProps } from '@edge/spark/feature-mui-rhf-inputs'
import { StartLabelSelectField } from '@edge/spark/feature-mui-rhf-inputs'

export const SelectField: React.VFC<StartLabelSelectFieldProps> = (props: StartLabelSelectFieldProps) => {
    return (
        <StartLabelSelectField
            fullWidth
            InputLabelProps={{ shrink: true }}
            // SelectProps={{ displayEmpty: true }}
            variant="standard"
            {...props}
        />
    )
}
